const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const {
    Component
} = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @commons
import OKLayout from 'components/commons/OKLayout/OKLayout';
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { getLastNChars } = require('utilities/stringHelper');

// @actions
const accountsActions = require('actions/getAccounts');
const accountChequesActions = require('actions/accountCheques');

// @components
const AccountMoreOptionsButton = require('components/accounts/accountMoreOptionsButton/accountMoreOptionsButton');
const AccountChequesMovements = require('components/accounts/accountChequesMovements/accountChequesMovements');
import extendAccountFunctionality from 'components/accounts/extendAccountFunctionality/extendAccountFunctionality';

// @utilities
const AccessHelper = require('utilities/accessHelper');

// @constants
const { accountConstants } = require('utilities/accessHelperConditions/accounts');
import { NEGATIVE } from 'constants/layout';

class AccountChequesView extends Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { history, immAccounts, match: { params: { accountId } } } = this.props;
        AccessHelper.allowAccess(accountConstants.ACCOUNTS_CHEQUES, { immAccounts, accountId }, history);
    }

    renderButton = (accountId) => {
        const { handleOptionsClick } = this.props;
        return <AccountMoreOptionsButton accountId={accountId} onOptionClick={handleOptionsClick} />
    }

    render() {
        const { match: { params: { accountId } }, requestCheques, immAccountsCheques, immAccounts } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        const subtitleLeft = immAccount.get('catalogData').get('subtype');
        const subtitleRight = getLastNChars(immAccount.get('iban'));
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: immAccount.get('alias'),
                url: `/myprofile/accounts/${accountId}/movements`
            },
            {
                text: formatText('accountCheques-chequebooks'),
                url: ''
            }
        ];

        return (
            <OKLayout
                breadcrumb={mappingBreadcrumb}
                buttons={this.renderButton(accountId)}
                contentPosition={NEGATIVE}
                title={getFinalTitle('accountCheques-title')}
                loading={!immAccount}
                section="loansmortgages"
                subtitleLeft={subtitleLeft}
                subtitleRight={subtitleRight}
            >
                <OKSectionBox>
                    <div className="row">
                        <div className="col-xs-12">
                            <AccountChequesMovements
                                immAccount={immAccount}
                                requestCheques={requestCheques}
                                immCheques={immAccountsCheques.get(accountId)}
                            />
                        </div>
                    </div>
                </OKSectionBox>
            </OKLayout>
        )
    }
}

AccountChequesView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAccountsCheques: PropTypes.object.isRequired,
    requestAccounts: PropTypes.func.isRequired,
    requestCheques: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired
};

module.exports.constructor = AccountChequesView;
module.exports.AccountChequesView = connect(
    state => ({
        immAccounts: state.accounts,
        immAccountsCheques: state.accountsCheques
    }), {
    requestAccounts: accountsActions.requestAccounts,
    requestCheques: accountChequesActions.requestCheques
})(withRouter(extendAccountFunctionality(AccountChequesView)));
